import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const ENDPOINT_USERS = API_URL_VERSION + "usuarios";
export const ENDPOINT_USERS_LIST = ENDPOINT_USERS + "/listar";
export const ENDPOINT_CHANGE_PASSWORD = ENDPOINT_USERS + "/alterar-senha";

export const UserRole = {
  TRAFFIC_AGENT: { value: "AGENTE DE TRÂNSITO", labelKey: "traffic-agent" },
  GETRAN_ADVISORY: { value: "ASSESSORIA GETRAN", labelKey: "getran-advisory" },
  REGISTRATION: { value: "CADASTRO", labelKey: "registration" },
  RADIO_CENTER: { value: "CENTRAL DE RÁDIO", labelKey: "radio-center" },
  CYCLOMOB: { value: "CICLOMOB", labelKey: "cyclomob" },
  VTR_DRIVER: { value: "CONDUTOR DE VTR", labelKey: "vtr-driver" },
  TRAFFIC_COORDINATOR: { value: "COORDENADOR DE TRÂNSITO", labelKey: "traffic-coordinator" },
  CITY_COUNCIL: { value: "CÂMARA DOS VEREADORES", labelKey: "city-council" },
  DAT: { value: "DAT", labelKey: "dat" },
  DCOP: { value: "DCOP", labelKey: "dcop" },
  DET: { value: "DET", labelKey: "det" },
  STATISTICS: { value: "ESTATÍSTICA", labelKey: "statistics" },
  TRAFFIC_MANAGER: { value: "GERENTE DE TRÂNSITO", labelKey: "traffic-manager" },
  JARI: { value: "JARI", labelKey: "jari" },
  LEGAL: { value: "JURÍDICO", labelKey: "legal" },
  MAINTENANCE: { value: "MANUTENÇÃO", labelKey: "maintenance" },
  MONITORING: { value: "MONITORAMENTO", labelKey: "monitoring" },
  MOTORCYCLIST: { value: "MOTOCICLISTA", labelKey: "motorcyclist" },
  MOTORCYCLIST_CYCLOMOB: { value: "MOTOCICLISTA / CICLOMOB", labelKey: "motorcyclist-cyclomob" },
  PROJECTS: { value: "PROJETOS", labelKey: "projects" },
  PROTOCOL: { value: "PROTOCOLO", labelKey: "protocol" },
  SAA: { value: "SAA", labelKey: "saa" },
  SEMAPHORE: { value: "SEMAFÓRICA", labelKey: "semaphore" },
  SIGNAGE: { value: "SINALIZAÇÃO", labelKey: "signage" },
  SUPERVISION: { value: "SUPERVISÃO", labelKey: "supervision" },
  IT: { value: "TI", labelKey: "it" },
};

export const userService = {
  findMany: async (params = {}) => {
    try {
      const searchParams = toSearchFilter(params);
      const response = await api.get(ENDPOINT_USERS, { params: searchParams });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.messages.errors.list";
    }
  },

  list: async (params = {}) => {
    try {
      const searchParams = toSearchFilter(params);
      const response = await api.post(ENDPOINT_USERS_LIST, searchParams);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_USERS, data);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.erros_validacao || "settings.user.messages.errors.create";
      throw errorMessage;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_USERS}/${id}`, data);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.erros_validacao || "settings.user.messages.errors.update";
      throw errorMessage;
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_USERS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.messages.errors.list";
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_USERS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.messages.errors.delete";
    }
  },

  changePassword: async (formBody) => {
    try {
      const response = await api.put(`${ENDPOINT_CHANGE_PASSWORD}`, formBody);
      if (response.status === 200) {
        return { msg: "ok" };
      }
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.erros_validacao || "settings.user.messages.errors.update";
      throw errorMessage;
    }
  },

}